// extracted by mini-css-extract-plugin
module.exports = {"gray-light":"#eeeeed","pageBanner":"PageBanner-module__pageBanner___1MvgQ","grayPattern":"PageBanner-module__grayPattern___2KGPv","inner":"PageBanner-module__inner___3FcvZ"};